export default __webpack_public_path__ + "static/Pala_17-0e3e3167db4fbf25e5e938364a9f15ec.png";